import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router';

export type RouteFragmentController = Readonly<{
  current: string;
  change: (value: string) => void;
  clear: () => void;
}>;

// // URL: /path?x=1#section-1
// fragment.current; // "section-1"
// fragment.change('details');
// // /path?x=1#details
// fragment.change('#details');
// // también /path?x=1#details
// fragment.clear();
// // /path?x=1
export function useUrlFragmentSync(): RouteFragmentController {
  const location = useLocation();
  const navigate = useNavigate();

  const commit = useCallback(
    (fragment: string) => {
      const hash = fragment ? `#${fragment.replace(/^#+/, '')}` : '';

      if (hash === location.hash) return;

      navigate(
        {
          pathname: location.pathname,
          search: location.search,
          hash,
        },
        {
          state: location.state,
        }
      );
    },
    [location, navigate]
  );

  const change = useCallback(
    (value: string) => {
      commit(value);
    },
    [commit]
  );

  const clear = useCallback(() => {
    commit('');
  }, [commit]);

  return useMemo(
    () =>
      Object.freeze({
        current: location.hash.replace(/^#/, ''),
        change,
        clear,
      }),
    [change, clear, location.hash]
  );
}
